import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import { HttpService } from '@/app/core/services/http';

import {
  Addons,
  Subscription,
  AdditionalAdsType,
  SubscriptionDetails,
  AdditionalAdsPreview,
} from './subscriptions.types';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionsService {
  constructor(private http: HttpService) {}

  getCurrentUserSubscription(): Observable<Subscription> {
    return this.http.get<Subscription>('subscription');
  }

  getCurrentUserSubscriptionDetails(): Observable<SubscriptionDetails> {
    return this.http.get<SubscriptionDetails>('subscription/details');
  }

  cancelSubscription(): Observable<Subscription> {
    return this.http.delete<Subscription>('subscription');
  }

  renewSubscription(): Observable<Subscription> {
    return this.http.post<Subscription>('subscription/renew', {});
  }

  getAddonsList(): Observable<Addons[]> {
    return this.http.get<Addons[]>('subscription/addons');
  }

  reduceAddonsAmount(addonPriceId: string, quantity: number): Observable<void> {
    return this.http.post<void>('subscription/addons/decrease', { addon_price_id: addonPriceId, quantity });
  }

  purchaseAddonsAmount(addonPriceId: string, quantity: number): Observable<void> {
    return this.http.post<void>('subscription/addons/purchase', { addon_price_id: addonPriceId, quantity });
  }

  getSubscriptionPricePreview(
    addonPriceId: string,
    quantity: number,
    type: AdditionalAdsType,
  ): Observable<AdditionalAdsPreview> {
    return this.http.get<AdditionalAdsPreview>('subscription/preview-invoice', {
      params: {
        addon_price_id: addonPriceId,
        quantity: quantity,
        type: type,
      },
    });
  }
}
